export function isCustomerConnectionReturnPath(path: string) {
  return ['/customer/jtl-connect','/customer/stores/amazon-v2/new','/customer/stores/amazon/new'].some(base => path === base || path.startsWith(base+'?'));
}
